import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Analyst } from '@analysis/domain';
import { IAnalysisState } from '@analysis/domain';

@Component({
    selector: 'ts-analyst-selector',
    templateUrl: './analyst-selector.component.html',
    styleUrls: ['./analyst-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AnalystSelectorComponent {
  @Input() public readonly isCurrentUser: boolean;
  @Input() public readonly analystSelected: Analyst;
  @Input() public readonly analysts: Analyst[];
  @Input() public readonly analysisStates: Map<string, IAnalysisState>;
  @Input() public readonly editingEnabled = false;

  @Output() analystChange = new EventEmitter<Analyst>();
  @Output() toogleReference = new EventEmitter<void>();

  getStateFor(id: string): IAnalysisState | undefined {
    return this.analysisStates.get(id);
  }

  public compareAnalysts = (a: Analyst | null, b: Analyst | null): boolean => a?.id === b?.id;
}
